import { Target, Compass } from "lucide-react";

export default function MissionVision() {
  return (
    <section id="mission" data-testid="mission-section" className="bg-[#F4F1EB]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-24 sm:py-32">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#8B2635] mb-4">
            What Guides Us
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl text-[#2C2A29] leading-[1.05] tracking-tight">
            A clear purpose. A patient, generational vision.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          <div
            data-testid="mission-card"
            className="relative rounded-3xl bg-[#FAF8F5] border border-[#E2DCD0] p-10 md:p-12 hover:shadow-md transition-all"
          >
            <div className="w-12 h-12 rounded-full bg-[#692128] text-[#F4F1EB] flex items-center justify-center mb-6">
              <Target size={20} strokeWidth={2} />
            </div>
            <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#8B2635] mb-3">
              Our Mission
            </div>
            <p className="font-serif text-2xl sm:text-3xl text-[#2C2A29] leading-snug">
              To strengthen families, empower caregivers, support community wellness, and
              improve quality of life for veterans and vulnerable populations — through
              <span className="italic text-[#692128]"> compassion, advocacy, and service</span>.
            </p>
          </div>

          <div
            data-testid="vision-card"
            className="relative rounded-3xl bg-[#2A4747] text-[#F4F1EB] p-10 md:p-12 overflow-hidden"
          >
            <div className="w-12 h-12 rounded-full bg-[#C89F5D] text-[#2C2A29] flex items-center justify-center mb-6">
              <Compass size={20} strokeWidth={2} />
            </div>
            <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#C89F5D] mb-3">
              Our Vision
            </div>
            <p className="font-serif text-2xl sm:text-3xl leading-snug">
              A Community Resource Center &amp; Family Support Hub — a safe, loving,
              empowering place where families can grow stronger together.
            </p>
            <div className="absolute -right-12 -bottom-12 w-48 h-48 rounded-full bg-[#C89F5D]/15 blur-2xl pointer-events-none" />
          </div>
        </div>
      </div>
    </section>
  );
}
